// extracted by mini-css-extract-plugin
module.exports = {"fileViewWrapper":"OutsideLinkView_fileViewWrapper__3wYLC","expiredWrapper":"OutsideLinkView_expiredWrapper__3_5Uj"};